export default __webpack_public_path__ + "src/components/pages/login/customers/779737e1b84be1d24520d79a3825bca3.png";